module.exports = __webpack_public_path__ + "img/305.fa4c5a43.png";